// extracted by mini-css-extract-plugin
module.exports = {"label":"RadioInput_label__1ysVq","label_text":"RadioInput_label_text__1sxpO","radio":"RadioInput_radio__1ku8W"};